import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import UnifiedProfiles from './domains/unified-profiles';

/**
 * Root component of the Unified Profiles application.
 * Mounted by the Core Shell under <Route path="unified-profiles/*">.
 * Also usable standalone via main.jsx.
 *
 * Renders no router, auth provider or theme provider — the shell owns all
 * three, and mounting a second of any of them is what breaks an embedded app.
 */
function UnifiedProfilesApp() {
  const { ready, t } = useTranslation('unified-profiles');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <ToastProvider config={{ position: 'top-right', defaultDuration: 4000 }}>
      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <UnifiedProfiles />
      </div>
    </ToastProvider>
  );
}

export default UnifiedProfilesApp;
